import { useQuery } from '@tanstack/react-query';
import { supabase } from '../lib/supabase';

export interface EstimateMetrics {
  inProgress: number;
  sent: number;
  awaitingReply: number;
  pipelineValue: number;
}

interface EstimateMetricRow {
  id: string;
  status: string | null;
  total_cents: number | null;
  proposal_sent_at: string | null;
  m365_last_reply_at: string | null;
}

export function useEstimateMetrics() {
  return useQuery({
    queryKey: ['estimate-metrics'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('estimates')
        .select('id, status, total_cents, proposal_sent_at, m365_last_reply_at');
      if (error) throw error;

      const estimates: EstimateMetricRow[] = data ?? [];
      const inProgress = estimates.filter((e: EstimateMetricRow) => e.status === 'draft').length;
      const sent = estimates.filter((e: EstimateMetricRow) => e.status === 'sent').length;
      const awaitingReply = estimates.filter((e: EstimateMetricRow) => e.status === 'sent' && !e.m365_last_reply_at).length;
      const pipelineValue = estimates
        .filter((e: EstimateMetricRow) => e.status === 'draft' || e.status === 'sent')
        .reduce((sum: number, e: EstimateMetricRow) => sum + (e.total_cents ?? 0), 0);

      return { inProgress, sent, awaitingReply, pipelineValue } satisfies EstimateMetrics;
    },
    staleTime: 2 * 60 * 1000,
  });
}
